import React from 'react'
import clsx from 'clsx'
import { useAppSelector } from '../../../hooks/redux'

import { selectConvo } from '../../../slices/convo'
import useStyles from './styles'

const ReasonBlock = ({ id, className, onTop }) => {
  const { allConversations } = useAppSelector(selectConvo)

  const [reason, setReason] = React.useState(null)

  const classes = useStyles()

  React.useEffect(() => {
    const convo = allConversations[id]
    if (convo) {
      setReason(convo.topic)
    }
  }, [id, allConversations])

  if (!reason) {
    return null
  }

  return (
    <div className={clsx(classes.root, className)}>
      <div className={clsx(classes.container, onTop && classes.darkBorder)}>
        <div className={classes.help}>I need help with...</div>

        <div className={classes.reason}>{reason}</div>
      </div>
    </div>
  )
}

export default ReasonBlock
